module.exports = __webpack_public_path__ + "static/img/nutrenaklientportal2.573a62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nutrenaklientportal2.png
// module id = 666
// module chunks = 1